export const environment = {
  production: false,
  apigwUrl: 'https://api-ha-dev.sc.geappl.io/eola',
  apiGateway: {
    url: "https://api-ha-dev.sc.geappl.io/",
    stage: "eola"
  },  
  AllowScreenAuth: true,  
  cognitoOptionsHA: [
    {
      Region: "us-east-1",
      ClientId: '68h4jq5b3oi4qq02690p6ve3k2', // Your client id here
      AppWebDomain: 'mesauth.auth.us-east-1.amazoncognito.com', // Exclude the "https://" part.
      TokenScopesArray: ['openid', 'profile', 'email'],
      UserPoolId: 'us-east-1_s1pKZcsUG',
      AdvancedSecurityDataCollectionFlag: false
    },
    {
      Region: "us-west-2",
      ClientId: '6f31obccim9tjmo62lvk3cgaou', // Your client id here
      AppWebDomain: 'mesauth.auth.us-west-2.amazoncognito.com', // Exclude the "https://" part.
      TokenScopesArray: ['openid', 'profile', 'email'],
      UserPoolId: 'us-west-2_R29ioKZps',
      AdvancedSecurityDataCollectionFlag: false
    }
  ]
};